export class EngineerSignUP {
  public mostCurrentAirframe: string = '';
  public latestRank: string = '';
  public currentJobTitle: string = '';
  public mostRecentEmployer: any = '';
  public currentEngineType: string = '';

  public otherEngineType: string = '';
  public licenceType: any = {};
  public otherLicenceType: string = '';
  public licenseAuthority: string = '';
  public othetLicenceAuthority: string = '';
  public licenceCountry: any = {};

  //not used currently
  public passportCountries: string[] = [];
  public otherPassportCountryId = '';
  public otherRecentAirframe: string = '';
}
